import { Window } from "./Window";
import { Iframe } from "../../Iframe";
import { toMap } from "../../../../../HA";

export class ExtWindow extends Window {
    protected initialize(data: any) {
        super.initialize(data);
        this.initFrame(toMap(data) as Map<any, any>);
    }

    protected initFrame(d: Map<any, any>) {
        d.delete("tag");
        d.delete("element");
        this.appendChild(new Iframe(d));
    }
}
